export default __webpack_public_path__ + "static/media/alsoAvaOnAppStore.08cd04f6.png";